import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import WizardFormIntro from "./WizardFormIntro";
import WizardFormOptOut from "./WizardFormOptOut";
import WizardFormEmployeeInfo01 from "./WizardFormEmployeeInfo01";
import WizardFormEmployeeInfo02 from "./WizardFormEmployeeInfo02";
import WizardFormSection01 from "./WizardFormSection01";
import WizardFormSection02 from "./WizardFormSection02";
import WizardFormSection03 from "./WizardFormSection03";
import WizardFormSection04 from "./WizardFormSection04";
import WizardFormSection05 from "./WizardFormSection05";
import WizardFormSection06 from "./WizardFormSection06";
import WizardFormSection06b from "./WizardFormSection06b";
import WizardFormSection06c from "./WizardFormSection06c";
import WizardFormSection07 from "./WizardFormSection07";
import WizardFormSection08 from "./WizardFormSection08";
import WizardFormSection09 from "./WizardFormSection09";
import WizardFormSection09b from "./WizardFormSection09b";
import WizardFormSection10 from "./WizardFormSection10";
import WizardFormSummary from "./WizardFormSummary";
import WizardFormIRS8850 from "./WizardFormIRS8850";
import WizardFormETA9175 from "./WizardFormETA9175";
import ThankYou from "./ThankYou";
import { DEFAULT_WIZARD_FORM_VALUES } from "../constants/defaultValues";

const SUBMITTED_AT_FORMAT = "YYYY-MM-DDTHH:mm";

class WizardForm extends Component {
  state = {
    page: 1,
  };

  changePage = pageIncrement => {
    this.props.switchLanguageBack();
    this.setState({ page: this.state.page + pageIncrement });
  };

  ageWithinRange = (birthDate, minAge, maxAge) => {
    const age = moment().diff(birthDate, "years");
    return age >= minAge && age < maxAge;
  };

  nextPage = () => this.changePage(1);
  nextPageSkip = () => this.changePage(2);
  previousPage = () => this.changePage(-1);
  previousPageSkip = () => this.changePage(-2);

  startOver = () => {
    this.setState({ page: 1 });
  };

  updateStore = data => {
    const {
      actions: { submitResponse },
      employee: { id },
      subdomain,
    } = this.props;

    const {
      birthMonth,
      birthDay,
      birthYear,
      dischargeMonth,
      dischargeYear,
      convictionMonth,
      convictionYear,
      releaseMonth,
      releaseYear,
      unemploymentStartYear,
      unemploymentStartMonth,
      unemploymentStartDay,
      summarySignatureDay,
      summarySignatureMonth,
      summarySignatureYear,
      irsSignatureDay,
      irsSignatureMonth,
      irsSignatureYear,
      dolSignatureDay,
      dolSignatureMonth,
      dolSignatureYear,
      ...responses
    } = data;

    const employee = {
      ...responses,
      birth_date:
        birthYear && birthMonth && birthDay
          ? moment(birthYear + birthMonth + birthDay, "YYYY-MM-DD").toString()
          : null,
      qualifies_age_range: this.ageWithinRange(
        moment(birthYear + birthMonth + birthDay, "YYYY-MM-DD"),
        16,
        40
      ),
      discharge_date:
        dischargeYear && dischargeMonth
          ? moment(dischargeYear + dischargeMonth, "YYYY-MM").toString()
          : null,
      conviction_date:
        convictionYear && convictionMonth
          ? moment(convictionYear + convictionMonth, "YYYY-MM").toString()
          : null,
      release_date:
        releaseYear && releaseMonth
          ? moment(releaseYear + releaseMonth, "YYYY-MM").toString()
          : null,
      unemployment_start_date:
        unemploymentStartYear && unemploymentStartMonth && unemploymentStartDay
          ? moment(
              unemploymentStartYear +
                unemploymentStartMonth +
                unemploymentStartDay,
              "YYYY-MM-DD"
            ).toString()
          : null,
      summary_signature_date:
        summarySignatureYear && summarySignatureMonth && summarySignatureDay
          ? [
              summarySignatureYear,
              summarySignatureMonth,
              summarySignatureDay,
            ].join("-")
          : null,
      irs_signature_date:
        irsSignatureYear && irsSignatureMonth && irsSignatureDay
          ? [irsSignatureYear, irsSignatureMonth, irsSignatureDay].join("-")
          : null,
      dol_signature_date:
        dolSignatureYear && dolSignatureMonth && dolSignatureDay
          ? [dolSignatureYear, dolSignatureMonth, dolSignatureDay].join("-")
          : null,
      submitted_at: moment().format(SUBMITTED_AT_FORMAT),
      subdomain,
    };

    submitResponse(id, employee);
  };

  submitOptOut = data => {
    const {
      actions: { submitResponse },
      employee: { id },
      subdomain,
    } = this.props;
    const employee = {
      ...data,
      opt_out: true,
      submitted_at: moment().format(SUBMITTED_AT_FORMAT),
      subdomain,
    };
    submitResponse(id, employee);
  };

  render() {
    const queryParams = this.props.location.query;
    const {
      allText,
      language,
      switchToEnglish,
      switchLanguageBack,
      employee,
      logo,
    } = this.props;
    const { page } = this.state;

    const props = {
      language,
      switchToEnglish,
      switchLanguageBack,
      allText: allText[language],
      allTextEnglish: allText.english,
      employee,
      queryParams,
      previousPage: this.previousPage,
      onSubmit: this.nextPage,
    };

    const pages = [
      <WizardFormOptOut
        {...props}
        key="optout"
        onSubmit={this.submitOptOut}
        handleContinue={this.nextPageSkip}
      />,
      <WizardFormIntro
        {...props}
        key="intro"
        onOptOut={this.previousPage}
        logo={logo}
      />,
      <WizardFormEmployeeInfo01 {...props} key="info01" />,
      <WizardFormEmployeeInfo02 {...props} key="info02" />,
      <WizardFormSection01 {...props} key="section01" />,
      <WizardFormSection02 {...props} key="section02" />,
      <WizardFormSection03 {...props} key="section03" />,
      <WizardFormSection04 {...props} key="section04" />,
      <WizardFormSection05 {...props} key="section05" />,
      <WizardFormSection06 {...props} key="section06" />,
      <WizardFormSection06b {...props} key="section06b" />,
      <WizardFormSection06c {...props} key="section06c" />,
      <WizardFormSection07
        {...props}
        key="section07"
        previousPage={() => this.changePage(-3)}
      />,
      <WizardFormSection08 {...props} key="section08" />,
      <WizardFormSection09 {...props} key="section09" />,
      <WizardFormSection09b {...props} key="section09b" />,
      <WizardFormSection10
        {...props}
        key="section10"
        previousPage={this.previousPageSkip}
      />,
      <WizardFormSummary {...props} key="summary" />,
      <WizardFormIRS8850 {...props} key="irs" previousPage={this.startOver} />,
      <WizardFormETA9175
        {...props}
        key="dol"
        previousPage={this.startOver}
        onSubmit={this.updateStore}
      />,
    ];

    return (
      <div>
        {(!this.props.data.submitted && <div>{pages[page]}</div>) || (
          <ThankYou
            employee={employee}
            submittedText={allText[language].submitted}
          />
        )}
      </div>
    );
  }
}

WizardForm.propTypes = {
  actions: PropTypes.object.isRequired,
  allText: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  page: PropTypes.number,
  switchLanguageBack: PropTypes.func.isRequired,
  switchToEnglish: PropTypes.func.isRequired,
};

WizardForm.defaultProps = DEFAULT_WIZARD_FORM_VALUES;

export default WizardForm;



// WEBPACK FOOTER //
// ./src/components/WizardComponent.js